module.exports = __webpack_public_path__ + "img/getty.8ad4aa79.jpg";